import request from "../services/HTTPClient";
import { requestMethods, API } from "../constants";

const isFallbackCandidate = (error) => {
  const status = error?.status;
  if (status === 404 || status === 405 || status === 501) {
    return true;
  }

  const message = String(error?.data?.message || '').toLowerCase();
  return status === 400 && message.includes('ids') && message.includes('arreglo');
};

const runWithFallback = async (attempts) => {
  let lastError;

  for (let index = 0; index < attempts.length; index += 1) {
    try {
      return await request(attempts[index]);
    } catch (error) {
      lastError = error;
      if (!isFallbackCandidate(error)) {
        throw error;
      }
    }
  }

  throw lastError;
};

function ChangeStatus(request_body) {
  return request({
    method: requestMethods.POST,
    url: API.NOTIFICATIONS.CHANGE_STATUS.concat(request_body),
  });
}

function MarkAsRead(request_body) {
  return MarkNotificationsAsRead(request_body?.keys || []);
}

function MarkNotificationAsRead(notificationId) {
  const notificationUrl = API.NOTIFICATIONS.NOTIFICATIONS_READ.replace(':id', notificationId);
  const fallbackPayload = { keys: [notificationId] };

  return runWithFallback([
    {
      method: requestMethods.PATCH,
      url: notificationUrl,
    },
    {
      method: requestMethods.POST,
      url: notificationUrl,
    },
    {
      method: requestMethods.PUT,
      url: notificationUrl,
    },
    {
      method: requestMethods.POST,
      url: API.NOTIFICATIONS.MARK_AS_READ,
      data: fallbackPayload,
    }
  ]);
}

function MarkNotificationsAsRead(notificationIds = []) {
  const ids = (notificationIds || [])
    .filter((id) => id !== null && id !== undefined && id !== '')
    .map((id) => String(id));

  if (ids.length === 0) {
    return Promise.resolve({ data: { success: true, skipped: true } });
  }

  const attempts = [
    {
      method: requestMethods.PATCH,
      url: API.NOTIFICATIONS.NOTIFICATIONS_READ_ALL,
      data: { ids },
    },
    {
      method: requestMethods.PUT,
      url: API.NOTIFICATIONS.NOTIFICATIONS_READ_ALL,
      data: { ids },
    },
    {
      method: requestMethods.POST,
      url: API.NOTIFICATIONS.NOTIFICATIONS_READ_ALL,
      data: { ids },
    },
  ];

  attempts.push({
    method: requestMethods.POST,
    url: API.NOTIFICATIONS.MARK_AS_READ,
    data: { keys: ids },
  });

  return runWithFallback(attempts);
}

function GetNotifications(user_id) {
  return request({
    url: API.NOTIFICATIONS.GET_NOTIFICATIONS.concat(user_id),
    method: requestMethods.GET,
  }).then(response => {
    return response;
  });
}

function GetNotification() {
  return request({
    url: API.NOTIFICATIONS.GET_NOTIFICATION,
    method: requestMethods.GET,
  });
}

async function CreateNotification(notificationData) {
  const payload = {
    ...notificationData,
  };

  const attempts = [
    {
      method: requestMethods.POST,
      url: API.NOTIFICATIONS.GET_NOTIFICATIONS,
      data: payload,
    },
    {
      method: requestMethods.POST,
      url: 'notifications/new',
      data: payload,
    },
    {
      method: requestMethods.POST,
      url: '/notifications/new',
      data: payload,
    },
    {
      method: requestMethods.POST,
      url: 'notifications',
      data: payload,
    },
    {
      method: requestMethods.POST,
      url: '/notifications',
      data: payload,
    },
  ];

  let lastError;
  for (let index = 0; index < attempts.length; index += 1) {
    try {
      return await request(attempts[index]);
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError;
}

function CreateNotificationsForUsers(userIds = [], data = {}) {
  const uniqueIds = [...new Set((userIds || []).filter(Boolean))];

  if (uniqueIds.length === 0) {
    return Promise.resolve([]);
  }

  return Promise.allSettled(
    uniqueIds.map((userId) =>
      CreateNotification({
        ...data,
        user_id: userId,
        userId,
        receiver_id: userId,
        recipient_id: userId,
      })
    )
  );
}

const NotificationService = {
  ChangeStatus,
  MarkAsRead,
  MarkNotificationAsRead,
  MarkNotificationsAsRead,
  GetNotifications,
  GetNotification,
  CreateNotification,
  CreateNotificationsForUsers,
};

export default NotificationService;
